/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { Button, Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  TextField,
} from '@material-ui/core';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { providerAndClaimColoumData } from './gridComponent/TableHead';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

import {
  closeTab,
  convertQuaterFromDate,
  convertQuaterToDate,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../../Display/NDC/store/action';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import CheckBoxRender from './gridComponent/CheckBoxRender';
import {
  dispatchClaimsDetailHeader,
  dispatchSaveUpdateProviderSumm,
  getDisputedClaimDetailsGrid,
  setDispatchProviderSummaryGrid,
  getProviderSummarySave,
  dispatchFullScrrenProviderSumm,
  dispatchProviderSummTabData,
  dispatchErrorMsgPerformDis,
  getProviderSummaryGridData,
  dispatchProviderSummaryGrid,
} from '../store/actions';
import { getProviderDetails } from '../../../Research/ClaimAudits/store/actions';
import {
  dispatchProvideDetails,
  getProviderIdTypeDetails,
} from '../../../Display/Provider/store/action';
import { navToProviderSummary } from './ConstantData';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { navigateToProvider } from '../../../Display/Claim/store/action';
import {
  dispatchActiveInvoiceNumber,
  getRosiAllocatePaymentDetail,
} from '../../AllocatePayments/store/Actions';
import { getAllocatePaymentScreenData } from '../../AllocatePayments/components/gridComponents/ROSIUtils';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const ProviderSummary = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const requestProviderSummaryData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.setProviderSummaryAndGrid
  );
  const providerSummaryTabData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.providerSummTabObj
  );

  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const providerSummaryHeaderData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.setProviderHeader
  );
  const sumOfCountData = useSelector( 
       (state) => 
          state?.sharedState?.PerformDisputeResolutionReducer?.sumCount  
      );
  const providerGridFullScrren = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.providerGridFullScrren
  );

  const providerSummaryGridData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.providerSummaryGrid
  );
  const providerSummaryGridDataObj = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.providerSummaryGridObj
  );
  const searchParams = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.disputeResolutionDetailObj
  );
  const saveOrUpdateMessage = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.updateProviderSummarySave
  );
  const getErrorMsg = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.errorMsgPerDisRes
  );
  const getInvoiceDetail = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.invoiceDetail
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const AllocatePaymentReducer = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer
  );
  const gridRef = React.useRef();
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [showComments, setShowComments] = React.useState(false);
  const [tableData, setTableData] = React.useState();
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [linkTableName, setLinkTableName] = React.useState('PROVIDER');
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] = useState(true);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const [rowGridPrimaryKey, setRowGridPrimaryKey] = useState('');
  const [gridApi, setGridApi] = useState(null);
  const [gridParams, setGridParams] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [warningAlert, setWarningAlert] = React.useState(false);
  const [warningMessage, setWaringMessage] = React.useState('');
  const RedColor='#a81f00';
  const [modalTitle, setModalTitle] = React.useState('');
  // fullscreen functionality
  const handleproviderGridFullScrren = () => {
    setFullScreenView(!fullScreenView);
    dispatch(dispatchFullScrrenProviderSumm(fullScreenView));
  };
  // on gride ready functionality
  const onGridReady = (params) => {
    setGridApi(params?.api);
    setGridParams(params);
  };

  // set Initial state values
  // on click on save
  const masterDataSave = () => {
    handleSaveClose();
    handelCancelClose();
    const saveRequest = providerSummaryGridData
      ?.filter((x) => {
        return x.isUpdate;
      })
      ?.map((item) => {
        return {
          providerId: item.providerId,
          providerReviewSeqNum: item.reviewSeqNum,
          providerIdTypeCd: item.providerIdTypeCd,
          reviewComplete: item.reviewComplete,
          selectForReview: item.reviewSelect,
          userId: logInUser,
        };
      });
    dispatch(getProviderSummarySave(saveRequest));
    setOpen(false);
  };
  // setting the dispute code value
  const getValues = providerSummaryHeaderData?.data;
  const obj = {};
  obj.ccDisputeCd1 = getValues?.ccDisputeCd1 ? getValues.ccDisputeCd1 : null;
  obj.ccDisputeCd2 = getValues?.ccDisputeCd2 ? getValues.ccDisputeCd2 : null;
  obj.ccDisputeCd3 = getValues?.ccDisputeCd3 ? getValues.ccDisputeCd3 : null;
  const getData = Object.values(obj);
  let getDisputedCodeValue = '';
  if (getData?.length > 0) {
    getData
      .filter((x) => {
        return x !== ' ';
      })
      .map((item, key) => {
        if (
          key !==
          getData.filter((x) => {
            return x !== ' ';
          }).length -
            1
        ) {
          getDisputedCodeValue += `${item} ,`;
        } else {
          getDisputedCodeValue += item;
        }
        return item;
      });
  }
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj =
        providerSummaryGridData &&
        providerSummaryGridData?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      dispatch(setDispatchProviderSummaryGrid(tempObj));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api?.refreshCells();
    }
  }, [commentsList]);
  // handing go to Provider redirection
  const handleViewProvider = async (rowData) => {
    const payLoadForProvider = {
      providerId: rowData?.providerId,
      providerIdTypeCd: rowData?.providerIdType,
    };
    dispatch(getProviderIdTypeDetails());
    dispatch(
      navigateToProvider(payLoadForProvider, () => {
        redirectURLLink(
          '/ProviderDetails',
          'Provider Details',
          history,
          dispatch
        );
      })
    );
  };
  // handing NDC detail page redirect
  const handleViewDetailsForNDC = async () => {
    const response = await getNDCDetails([
      {
        ndc: providerSummaryHeaderData?.data?.ndc,
        drugName: providerSummaryHeaderData?.data?.drugName,
      },
    ]);
    dispatch(setNDCErrorPopupMessage(null));
    dispatch(setCurrentNDCDetailsIndex(1));
    dispatch(setCurrentNDCDetailsSelected(response[0]));
    dispatch(
      setNDCDetails([
        {
          ndc: providerSummaryHeaderData?.data?.ndc,
          drugName: providerSummaryHeaderData?.data?.drugName,
        },
      ])
    );
    redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
  };
  // handle after call service show success and error message
  React.useEffect(() => {
    const localErr = getErrorMsg || [];
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      setDisabledSaveCancelBtn(true);
      dispatch(
        dispatchProviderSummTabData({
          disabledSaveCancelBtn: true,
          successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
        })
      );
      const payLoadObj = {
        drugSeqNum: providerSummaryHeaderData?.payloadProvider?.drugSeqNum,
        rebateProgramCd:
          providerSummaryHeaderData?.payloadProvider?.rebateProgramCd,
        qtr: providerSummaryHeaderData?.payloadProvider?.qtr,
      };
      dispatch(getProviderSummaryGridData(payLoadObj));
      if (!clickOncloseTabBtn) {
        dispatch(getProviderSummarySave(null));
        dispatch(dispatchProviderSummTabData({}));
        closeTab(navToProviderSummary, history);
      }
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj1 = updateTabs?.map((item) => {
        if (item.navTo === navToProviderSummary) {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
    } else if (saveOrUpdateMessage === 'failed') {
      localErr.push({
        field: 'APIFailed',
        errorType: 'APIFailed',
        message: constantMessageData.FAILED_MESSAGE_GENERIC,
      });
      dispatch(
        dispatchProviderSummTabData({
          ...providerSummaryTabData,
          disabledSaveCancelBtn: false,
        })
      );
      handleScrollToEvent();
      setSuccessMessage([]);
      setDisabledSaveCancelBtn(false);
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPerformDis(unique));
  }, [saveOrUpdateMessage]);
  // handing Go to ROSI /PQAS   redirection

  const goToROSIPQAS = async () => {
    const newObj = [];
    newObj.push({
      index: newObj.length,
      invoiceNum: getInvoiceDetail?.invoiceNum,
      checkLogNum: 0,
      active: true,
    });
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: getInvoiceDetail?.idecPrevInvoiceNum,
        checkLogNum: 0,
        checkPayeeCD: 'MD',
        checkAmt: 0,
        mfgId: getInvoiceDetail?.mfgId,
        planType: getInvoiceDetail?.rebateProgramCd,
      })
    );
    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    if (
      headerAllocatePaymentVO &&
      Object.keys(headerAllocatePaymentVO)?.length > 0
    ) {
      dispatch(dispatchActiveInvoiceNumber(newObj));
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj
      );
    } else if (data?.forzenCase) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.INVOICE_NUMBER_NOT_FROZEN);
    } else if (data?.noCheckPayeeForInvoice) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
    } else if (
      data?.headerAllocatePaymentVO == null &&
      data?.checkPayeeMessage
    ) {
      setWarningAlert(true);
      setWaringMessage(data?.checkPayeeMessage);
      setModalTitle('Warning');
    }
  };
  //  handling Go to Disputed Cliam Screen
  const handleViewDisputedClaim = async (cellData) => {
    const quarter = providerSummaryHeaderData?.payloadProvider?.qtr;
    const fromdate = quarter ? convertQuaterFromDate(quarter) : '';
    const todate = quarter ? convertQuaterToDate(quarter) : '';
    const payloadClaimsDetails = {
      rebateProgramCd:
        providerSummaryHeaderData?.payloadProvider?.rebateProgramCd,
      drugSeqNum: providerSummaryHeaderData.data.drugSeqNum,
      claimPaidBeginDate: fromdate,
      claimPaidEndDate: todate,
      providerUnused: '1',
      providerId: cellData?.providerId,
      providerIdTypeCd: cellData?.providerIdType,
      displayInvoiced: '1',
      displayNonInvoiced: '0',
    };
    const reqData = {
      payloadClaimsDetails,
      ndc: providerSummaryHeaderData?.data?.ndc,
      drugName: providerSummaryHeaderData?.data?.drugName,
      mfgName: providerSummaryHeaderData?.payloadProvider?.mfgName,
      mfgID: searchParams?.mfgID,
      quarter,
      rebateProgramCd:
        providerSummaryHeaderData?.payloadProvider?.rebateProgramCd,
    };
    const result = await dispatch(
      getDisputedClaimDetailsGrid(payloadClaimsDetails)
    );
    dispatch(dispatchClaimsDetailHeader(reqData));
    redirectURLLink(
      '/disputedClaimsDetail',
      'Disputed Claims Detail',
      history,
      dispatch
    );
  };
  // save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };
  // cancel popup
  const handelCancelClose = () => {
    setOpenCancel(false);
  };
  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    openSave(value);
  };
  // set Initial state values
  React.useEffect(() => {
    if (Object.keys(providerSummaryTabData)?.length === 0) {
      setDisabledSaveCancelBtn(true);
    } else {
      const tempObj = providerSummaryTabData;
      setDisabledSaveCancelBtn(tempObj.disabledSaveCancelBtn);
    }
  }, [providerSummaryTabData]);
  // handing refresh functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      providerSummaryTabData &&
      Object.keys(providerSummaryTabData).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === navToProviderSummary && !disabledSaveCancelBtn) {
          item.isFormDirty = true;
        } else if (item.navTo === navToProviderSummary)
          item.isFormDirty = false;
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!disabledSaveCancelBtn || providerSummaryTabData]);

  // handle close and confirm popup
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      dispatch(getProviderSummarySave(null));
    }
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs?.filter((x) => {
        return x.navTo === navToProviderSummary && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs?.map((item) => {
        if (item.navTo === navToProviderSummary && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // reset All fields after click cancel button
  const resetAllFields = () => {
    handelCancelClose();
    setSuccessMessage([]);
    setDisabledSaveCancelBtn('Yes');
    dispatch(dispatchProviderSummaryGrid([]));
    const payLoadObj = {
      drugSeqNum: providerSummaryHeaderData?.payloadProvider?.drugSeqNum,
      rebateProgramCd:
        providerSummaryHeaderData?.payloadProvider?.rebateProgramCd,
      qtr: providerSummaryHeaderData?.payloadProvider?.qtr,
    };
    dispatch(getProviderSummaryGridData(payLoadObj));
    dispatch(dispatchProviderSummTabData({}));
    handleScrollToEvent();
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs?.map((item) => {
        if (item.navTo === navToProviderSummary) {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };
  return (
    <div
      className=' tabs-container tBillPanel custom-check '
      data-testid='provider-summary'
    >
      <Spinner load={spinnerLoader} />
      {!providerGridFullScrren && (
        <CustomSeparator parent1='Tasks' parent2='Provider Summary' />
      )}

      {disabledSaveCancelBtn && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      <SaveCancelPopup
        open={open}
        data-testid='savePopup'
        title='Save'
        onConfim={() => {
          masterDataSave();
        }}
        onCancel={() => {
          handleSaveClose();
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        data-testid='cancelPopup'
        title='Cancel'
        onConfim={() => {
          resetAllFields();
        }}
        onCancel={() => {
          handelCancelClose();
        }}
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
        />
      ) : null}
      {!providerGridFullScrren && (
        <div className='row form-wrapper'>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='ndc-id'
              id='ndc-id'
              label='NDC'
              fullWidth
              disabled
              placeholder=''
              value={providerSummaryHeaderData?.data?.ndc}
              inputProps={{ maxLength: 38, id: 'ndc-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            {providerSummaryHeaderData?.data?.drugName &&
            providerSummaryHeaderData?.data?.drugName !== '' &&
            providerSummaryHeaderData?.data?.drugName.length > 25 ? (
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip id='labeler-tooltip'>
                    {providerSummaryHeaderData?.data?.drugName}
                  </Tooltip>
                }
              >
                <TextField
                  data-testid='drug-name-id-tooltip'
                  id='drug-name-id-tooltip'
                  label='Drug Name'
                  fullWidth
                  disabled
                  placeholder=''
                  value={
                    providerSummaryHeaderData?.data?.drugName != null &&
                    providerSummaryHeaderData?.data?.drugName.length > 0
                      ? `${providerSummaryHeaderData?.data?.drugName.substring(
                          0,
                          25
                        )}...`
                      : ''
                  }
                  inputProps={{ maxLength: 38, id: 'Name-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </OverlayTrigger>
            ) : (
              <TextField
                data-testid='drug-name-id'
                id='drug-name-id'
                label='Drug Name'
                fullWidth
                disabled
                placeholder=''
                value={providerSummaryHeaderData?.data?.drugName}
                inputProps={{ maxLength: 38, id: 'Name-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='provider-count-id'
              id='provider-count-id'
              label='Provider Count'
              fullWidth
              disabled
              placeholder=''
              value={providerSummaryGridData?.length}
              inputProps={{ maxLength: 38, id: 'provider-count-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='rebate-program-id'
              id='rebate-program-id'
              label='Rebate Program'
              fullWidth
              disabled
              value={
                providerSummaryHeaderData?.payloadProvider?.rebateProgramCd
              }
              placeholder=''
              inputProps={{ maxLength: 38, id: 'rebate-program-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='quarter-id'
              id='quarter-id'
              label='Quarter'
              fullWidth
              disabled
              placeholder=''
              value={providerSummaryHeaderData?.payloadProvider?.qtr}
              inputProps={{ maxLength: 38, id: 'quarter-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='claim-count-id'
              id='claim-count-id'
              label='Claim Count'
              fullWidth
              disabled
              placeholder=''
              value={
                sumOfCountData || '0'
              }
              inputProps={{ maxLength: 38, id: 'claim-count-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            {providerSummaryHeaderData?.payloadProvider?.mfgName &&
            providerSummaryHeaderData?.payloadProvider?.mfgName !== '' &&
            providerSummaryHeaderData?.payloadProvider?.mfgName.length > 25 ? (
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip id='labeler-tooltip'>
                    {providerSummaryHeaderData?.payloadProvider?.mfgName}
                  </Tooltip>
                }
              >
                <TextField
                  data-testid='manufacturer-name-tool-textField'
                  id='manufacturer-name-id-tooltip'
                  label='Manufacturer Name'
                  fullWidth
                  disabled
                  placeholder=''
                  value={
                    providerSummaryHeaderData?.payloadProvider?.mfgName !=
                      null &&
                    providerSummaryHeaderData?.payloadProvider?.mfgName.length >
                      0
                      ? `${providerSummaryHeaderData?.payloadProvider?.mfgName.substring(
                          0,
                          25
                        )}...`
                      : ''
                  }
                  inputProps={{ maxLength: 38, id: 'Name-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </OverlayTrigger>
            ) : (
              <TextField
                data-testid='manufacturer-name-id'
                id='manufacturer-name-id'
                label='Manufacturer Name'
                fullWidth
                disabled
                placeholder=''
                value={providerSummaryHeaderData?.payloadProvider?.mfgName}
                inputProps={{ maxLength: 38, id: 'Name-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='dispute-code-id'
              id='dispute-code-id'
              label='Dispute Code'
              fullWidth
              disabled
              placeholder=''
              value={getDisputedCodeValue}
              inputProps={{ maxLength: 38, id: 'dispute-code-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </div>
      )}
      {!providerGridFullScrren && (
        <div className='row d-flex flex-row-reverse m-2'>
          <div className='btn-wrapper'>
            <Button
              className='btn btn-success btn-save'
              data-testid='rcdd-process-button-submit'
              onClick={() => {
                onSubmit(true);
              }}
              disabled={disabledSaveCancelBtn}
            >
              <SVGComponent iconName='Icon-awesome-save' />
              &nbsp;Save
            </Button>
            <Button
              className='btn btn-cancel'
              data-testid='rcdd-process-button-cancel'
              onClick={() => handleOpenClose()}
              disabled={disabledSaveCancelBtn}
            >
              <SVGComponent iconName='Icon-cancel' />
              &nbsp;Cancel
            </Button>
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
          <TableGridWithFeatures
            data-testid='provider-summary-component-grid'
            rowSelection='single'
            rowMultiSelectWithClick={false}
            fullScreenView={providerGridFullScrren}
            handleFullScreenViewClick={handleproviderGridFullScrren}
            gridHeight={providerGridFullScrren ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            fileName='Provider and Claim details'
            columnDefs={providerAndClaimColoumData}
            rowData={providerSummaryGridData}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
                return (
                  <div className='tdCell icon-btn-group'>
                    {showComments ? (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
                      >
                        <Button
                          type='button'
                          aria-label='Comments'
                          onClick={() => {
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('PROVIDER');
                            setRowGridPrimaryKey(cellInfo?.data?.providerId);
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setLinkTableName('PROVIDER');
                              setRowGridPrimaryKey(cellInfo?.data?.providerId);
                              setShowComments(true);
                            }
                          }}
                          className={`th-ic comment-ic ${
                            parseInt(
                              cellInfo?.data?.ccCommentsExist,
                              [0, 1]
                            ) === 1
                              ? 'frr-enabled-comment-btn'
                              : 'frr-disabled-comment-btn'
                          }`}
                          variant='text'
                        >
                          {parseInt(cellInfo?.data?.ccCommentsExist, [0, 1]) ===
                          1 ? (
                            <img alt='comment ' src={CommentVisibleIcon} />
                          ) : (
                            <img alt='comment' src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      <Button
                        type='button'
                        onClick={() => {
                          setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                          setLinkTableName('PROVIDER');
                          setRowGridPrimaryKey(cellInfo?.data?.providerId);
                          setShowComments(true);
                        }}
                        tabIndex={'0'}
                        onKeyDown={(e) => {
                          // Handle Enter and Space key events
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // Prevents the default space scrolling behavior
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('PROVIDER');
                            setRowGridPrimaryKey(cellInfo?.data?.providerId);
                            setShowComments(true);
                          }
                        }}
                        className={`th-ic comment-ic ${
                          parseInt(cellInfo?.data?.ccCommentsExist, [0, 1]) ===
                          1
                            ? 'frr-enabled-comment-btn'
                            : 'frr-disabled-comment-btn'
                        }`}
                        variant='text'
                      >
                        {parseInt(cellInfo?.data?.ccCommentsExist, [0, 1]) ===
                        1 ? (
                          <img alt='comment' src={CommentVisibleIcon} />
                        ) : (
                          <img alt='comment' src={CommentIcon} />
                        )}
                      </Button>
                    )}
                    <Dropdown className='icon-dropdown-container float-right'>
                      <Dropdown.Toggle
                        className='icon-dropdown'
                        aria-label='Page Direct'
                      >
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='action-tooltip'>Action</Tooltip>
                          }
                        >
                          <SVGComponent iconName='Icon-export1' />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className='export_dropdown h-auto'>
                        <Dropdown.Item
                          role='button'
                          onClick={() => {
                            handleViewDisputedClaim(cellInfo?.data);
                          }}
                        >
                          Go to Claims
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() => {
                            handleViewProvider(cellInfo?.data);
                          }}
                        >
                          Go to Provider
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() => {
                            handleViewDetailsForNDC(cellInfo?.data);
                          }}
                        >
                          Go to NDC
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() => {
                            goToROSIPQAS();
                          }}
                        >
                          Go to ROSI /PQAS
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
              ProviderNameRender: (cellInfo) => {
                const name = cellInfo?.data?.providerName;
                if (name && name.length > 22) {
                  return (
                    <OverlayTrigger
                      placement='bottom'
                      overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
              totalAmtSubmittedCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.totalAmtSubmitted?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.totalAmtSubmitted
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.totalAmtSubmitted}`}</div>
                    )}
                  </>
                );
              },
              totalAllowedAmtCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.totalAllowedAmt?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.totalAllowedAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.totalAllowedAmt}`}</div>
                    )}
                  </>
                );
              },
              totalAmtReimbursedCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.totalAmtReimbursed?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.totalAmtReimbursed
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.totalAmtReimbursed}`}</div>
                    )}
                  </>
                );
              },
              amtPaidPerUnitCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.amtPaidPerUnit?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.amtPaidPerUnit
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.amtPaidPerUnit}`}</div>
                    )}
                  </>
                );
              },
              amtPaidForPrescriptionCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.amtPaidForPrescription
                      ?.toString()
                      .split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.amtPaidForPrescription
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.amtPaidForPrescription}`}</div>
                    )}
                  </>
                );
              },
              CheckBoxSelectedForRCellRender: CheckBoxRender,
              CheckBoxReviewCompliteCellRender: CheckBoxRender,
            }}
          />
        </div>
      </div>
      <CommonModal
        className='dialog-420'
        data-testid='commonModal1'
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => setWarningAlert(false)}
        onClose={() => setWarningAlert(false)}
        okTitle='Ok'
        modalTitle={modalTitle}
        childrenComponent={<div className='p-3'>{warningMessage}</div>}
      />
    </div>
  );
};
export default ProviderSummary;
